export const environment = {
  apiBaseUrl: 'https://wbd.scania.com/api',
  url: 'wbd.scania.com',
  production: true,
  msalConfig: {
    auth: {
      clientId: 'e7651d2e-3220-4801-bcf2-751bb0ff5694',
      authority: 'https://login.microsoftonline.com/3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac'
    },
  },
  webApi: {
    uri: 'https://wbd.scania.com/api',
    scopes: ['api://e6f275fc-9c7e-4a1c-a8ea-92f5a3fe0140/wbt-api.getpostdelete.any'],
  },
  apiConfig: {
    scopes: ['user.read'],
    uri: 'https://graph.microsoft.com/v1.0/me',
  },
  entraGroup: ""
};